import { render, staticRenderFns } from "./BranchDebt.vue?vue&type=template&id=5356b7c8&scoped=true"
import script from "./BranchDebt.vue?vue&type=script&lang=js"
export * from "./BranchDebt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5356b7c8",
  null
  
)

export default component.exports